module.exports = __webpack_public_path__ + "img/member_cash_icon.99a06b0e.png";